import React, { useState } from 'react';

export default function Tooltip({ text }) {
  const [show, setShow] = useState(false);
  if (!text) return null;
  return (
    <span className="relative inline-flex align-middle">
      <button
        type="button"
        tabIndex={-1}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        onClick={(e) => { e.preventDefault(); setShow((s) => !s); }}
        className="w-4 h-4 rounded-full bg-slate-200 text-slate-500 text-[10px] font-bold leading-none flex items-center justify-center hover:bg-ocean-100 hover:text-ocean-600 cursor-help shrink-0"
        aria-label="Info"
      >
        i
      </button>
      {show && (
        <span className="absolute z-50 left-1/2 -translate-x-1/2 bottom-full mb-2 w-64 text-xs leading-relaxed bg-slate-800 text-white rounded-lg p-2.5 shadow-lg">
          {text}
        </span>
      )}
    </span>
  );
}
